import { render, staticRenderFns } from "./LimitedTextArea.vue?vue&type=template&id=26b04ec9&scoped=true&"
import script from "./LimitedTextArea.vue?vue&type=script&lang=js&"
export * from "./LimitedTextArea.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTextArea.vue?vue&type=style&index=0&id=26b04ec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b04ec9",
  null
  
)

export default component.exports